import { Flex, PageHeader } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { PublishedProjectMutableGuard } from '@/features/authentication/_components/PublishedProjectMutableGuard';
import { useProject } from '@/features/project/_hooks/project';
import { ProjectsPageDynamicLink } from '@/features/project/projects/_components/ProjectsPageDynamicLink';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CommentSiderButton } from './CommentSiderButton';
import { ProjectActionsButton } from './ProjectActionsButton';
import { ProjectAndDiffSwitcher } from './ProjectAndDiffSwitcher';
import { ProjectDisplayGuard } from './ProjectDisplayGuard';
import { ProjectNameTitle } from './ProjectNameTitle';
import { WorkflowSiderButton } from './WorkflowSiderButton';

export const ProjectDetailsPageHeader: FC = () => {
  const { t } = useTranslation();
  const { id } = useId();

  const project = useProject(id);

  return (
    <PageHeader
      title={<ProjectNameTitle />}
      breadcrumbs={[
        { title: <ProjectsPageDynamicLink /> },
        { title: t('project-details-page') },
      ]}
      buttons={
        <ProjectDisplayGuard>
          <Flex gap={8}>
            <PublishedProjectMutableGuard>
              <ProjectAndDiffSwitcher />
              <WorkflowSiderButton name={project.data?.name} />
            </PublishedProjectMutableGuard>
            <PublishedProjectMutableGuard
              additionalAccessibleProjectRole={[
                'view',
                'edit',
                'privilege',
                'view-all-privilege',
              ]}
            >
              <CommentSiderButton
                peopleInChargeIds={project.data?.peopleInChargeIds}
                filteredOrganizationFiscalYear={project.data?.fiscalYear}
              />
            </PublishedProjectMutableGuard>
            <ProjectResourceGuard onlyEdit>
              <PublishedProjectMutableGuard>
                <ProjectActionsButton />
              </PublishedProjectMutableGuard>
            </ProjectResourceGuard>
          </Flex>
        </ProjectDisplayGuard>
      }
    />
  );
};
